<template>
  <div class="relative w-$portalContainerWidth h-[calc(100vh-210px)] mx-auto mt-20px">
    <NavigationBarProps></NavigationBarProps>
    <div class="w-full h-full">
      <iframe ref="iframe" :src="iframeUrl" frameborder="0" class="w-full h-full"></iframe>
    </div>
  </div>
</template>

<script>
import NavigationBarProps from '../components/NavigationBarProps'

export default {
  components: {
    NavigationBarProps,
  },
  data() {
    return {
      iframeUrl: '',
    }
  },
  computed: {
    flowid() {
      return this.$route.query.flowid
    },
    stepid() {
      return this.$route.query.stepid
    },
    taskid() {
      return this.$route.query.taskid
    },
    groupid() {
      return this.$route.query.groupid
    },
    instanceid() {
      return this.$route.query.instanceid
    },
  },
  mounted() {
    const loadUrl = `/flow/run/index?flowid=${this.flowid}&stepid=${this.stepid}&taskid=${this.taskid}&groupid=${this.groupid}&instanceid=${this.instanceid}`
    const flowServer = Wiz.GetModuleServer('road-flow-ele')
    this.iframeUrl = `${flowServer}/index.html?loadurl=${encodeURIComponent(
      loadUrl
    )}&nroadflow-token=${Wiz.AuthHooks.GetToken()}&isiframe=1`
  },
}
</script>

<style lang="scss" scoped></style>
